import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { APP_CONFIG } from '@shared/config/app-config.module';
import { environment } from './environments/environment';
import { appConfig } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

fetch('config/config.json')
	.then((response) => response.json())
	.then((config) => {
		if (environment.production) {
			enableProdMode();
		}

		appConfig.providers.push({provide: APP_CONFIG, useValue: config})
		
		bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
			.catch((err) => console.error(err));
	});
